/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { Card, Col, Layout, Row, Space, Typography } from "antd";
import { LeftCircleOutlined, CopyrightOutlined } from "@ant-design/icons";
import background from "../../assets/logo.png";
import packageJson from "../../../package.json";
import router from "../../components/History/index.component";
import { ReactComponent as LogoITCTradeNext } from "../../assets/itc_trade_next_logo.svg";

const { Header, Content, Footer } = Layout;
const { Title, Text } = Typography;

const NewRegistration: React.FC<any> = () => {
  return (
    <Layout>
      <Header
        style={{
          position: "fixed",
          top: 0,
          zIndex: 1,
          width: "100%",
          backgroundColor: "transparent",
        }}
      >
        <div>
          <LeftCircleOutlined
            style={{
              color: "#faad14",
              cursor: "pointer",
              fontSize: "xx-large",
              position: "fixed",
              left: 12,
              top: 14,
            }}
            onClick={() => {
              router.navigate("/signin");
            }}
          />
          <LogoITCTradeNext
            style={{
              width: "20em",
              cursor: "pointer",
            }}
            onClick={() => {
              router.navigate("/signin");
            }}
          />
        </div>
      </Header>
      <Content
        style={{
          padding: 0,
          minHeight: "100vh",
          backgroundColor: "rgb(255, 255, 255, 0.9)",
          // backgroundImage: `url(${background})`,
          // backgroundPosition: "top",
          // backgroundRepeat: "space repeat",
          // backgroundAttachment: "fixed",
          // backgroundBlendMode: "color-burn",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <Card
          style={{
            backgroundColor: "rgba(255,255,255,1)",
            boxShadow: "8px 10px 15px 2px rgba(0, 0, 0, 0.6)",
            height: "80vh",
          }}
          bordered={false}
        >
          <Row>
            <Col span={24}>
              <Title
                level={2}
                style={{
                  padding: 0,
                  margin: 0,
                  marginBottom: "0.1em",
                }}
              >
                New Vendor Inquiry
              </Title>
              <Text strong>Unlock Exclusive Application Access</Text>
            </Col>
          </Row>

          <Row>
            <Col>
              <embed
                width="640px"
                height="600px"
                src="https://forms.office.com/Pages/ResponsePage.aspx?id=pkf_tbT3v0qkhKdQV72BOQyo5csZHr1DjYJ0dKWFtpJUQldCMzRWOFJTSERUUFNRR1g2Uk1IQ0ZTSC4u&embed=true"
                style={{ border: "none", maxWidth: "100%", maxHeight: "65vh" }}
              />
            </Col>
          </Row>
        </Card>
      </Content>
      <Footer
        style={{
          position: "fixed",
          bottom: 0,
          width: "100%",
          display: "flex",
          justifyContent: "center",
          padding: 0,
        }}
      >
        <Text italic style={{ fontSize: "small", textAlign: "center" }}>
          Disclaimer: By sharing my mobile number and email id, I consent to
          being contacted by representatives of ITC Limited over call, email and
          other modes of communication.
          <br />
          <Text strong style={{ fontStyle: "normal", color: "#bfbfbf" }}>
            <CopyrightOutlined /> ITC Limited v{packageJson.version}
          </Text>
        </Text>
      </Footer>
    </Layout>
  );
};

export default NewRegistration;
